export default __webpack_public_path__ + "static/media/GT Sport.70d51281.png";